<template>
  <div class="setting-page-content license-setting">
    <h5>{{ $t('user.purchasedPackage') }}</h5>
    <div class="company-license row">
      <div v-for="(sub) in subscriptions" class="col-md-4 text-center">
        <div class="card mb-4 box-shadow" v-if="sub.plan_id.id">
          <div class="top-right-corner">
            <strong>
              {{$t('user.companyLicense')}}
            </strong>

          </div>
          <!--          <div class="card-header">
                      <h4 class="my-0 font-weight-normal">{{$t(`user.subscriptionPlan.${sub.plan_id.name}`)}}</h4>
                    </div>-->
          <div class="card-body">
            <img class="logo" width="150px" src="/images/license.png" alt="PVS License">
            <h3 class="font-weight-bold">
              <strong>
                {{ sub.plan_id.name }}
              </strong>
            </h3>
            <ul class="list-unstyled mt-2 mb-4">
              <li>
                <strong>
                  {{$t('user.subscriptionPlan.start')}} {{sub.start | formatDate}}
                </strong>
              </li>
              <li class="mt-2 light-grey">{{sub.plan_id.capacity}} {{ $t(`invoice.invoices`).toLowerCase() }}</li>
              <li class="mt-4">
                <strong>
                  {{$t('user.subscriptionPlan.price')}}
                </strong>
              </li>
              <li class="mt-2">
                <h3>
                  <strong class="primary-color">
                    {{sub.plan_id.price| formatNumber}} VNĐ
                  </strong>
                </h3>
              </li>
            </ul>
            <a target="_blank" href="https://pvssolution.com/lien-he/" class="btn btn-primary">
              {{$t('user.subscriptionPlan.buyMore')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import LicenseProxy from '@/store/proxies/license-proxy';

export default {
  name: 'LicenseSetting',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: '',
      subscriptions: [],
      planName: {

      },
    };
  },
  mounted() {
    new LicenseProxy().getSubscriptions().then((subscriptions) => {
      this.subscriptions = subscriptions.filter(sub => sub.service === 'EINVOICE');
    });
  },
  methods: {

  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/setting/license-setting.vue